import React, { useState, useRef, useEffect } from 'react';
import UserManagerInfo from './UserManagerInfo';
import UserManagerList from './UserManagerList';
import UserQRSInfo from './UserQRSInfo';

import './UserManagerMain.css';

const UserManagerMain = (props) => {

  return (
    <div id="manageUserBoxLR">
      <table width="100%" border="0" cellPadding="0">
        <tr>
          <td width="45%" valign="top">
            <div id="manageUserLeft">
              <UserManagerList handleClick={props.handleSelectedUser}  userLabelData={props.userLabelData}
                handleSearchBtn={props.handleSearchBtn} userFilter={props.userFilter} handleSearchInput={props.handleSearchInput} filteredArray={props.filteredArray}
              />
            </div>
          </td>
          <td width="55%" valign="top">
            <div id="manageUserRight">
              <UserManagerInfo selectedUser={props.selectedUser} />
              {props.selectedUser.userID ?
                <UserQRSInfo selectedUser={props.selectedUser} queryLabelData={props.queryLabelData} reportLabelData={props.reportLabelData} snapshotLabelData={props.snapshotLabelData}/>
                :undefined
              }
            </div>
          </td>
        </tr>
      </table>
    </div>
  )
}

export default UserManagerMain;